export type TMediaTypes = 'audioType' | 'audioTab' | 'videoType' | 'cameraType' | 'screenType' | 'speakerType';

export type TMediaRequest = {
  from_peer_name: string;
  from_peer_id: string;
  roleLabel: string;
  id?: string;
} | null;

export interface IAudioStream {
  id: string;
  type: 'audioType';
  peerId: string;
  peerName: string;
  volume: number;
  muted: boolean;
  autoPlay: boolean;
  stream: MediaStream;
  isCurrentUser?: boolean;
}

export enum EMediaType {
  audio = 'audioType',
  audioTab = 'audioTab',
  video = 'videoType',
  camera = 'cameraType',
  screen = 'screenType',
  speaker = 'speakerType',
}

export interface IExtendedMediaTrackConstraints extends MediaTrackConstraints {
  // Google/Chromium-specific constraints (non-standard but widely used)
  googEchoCancellation?: boolean;
  googAutoGainControl?: boolean;
  googNoiseSuppression?: boolean;
  googHighpassFilter?: boolean;
  googTypingNoiseDetection?: boolean;
  googArrayGeometry?: boolean;
}
